import axios from 'axios';

// 创建axios实例
const instance = axios.create({
  baseURL: 'http://image.c1.phym.cloud/api', // 根据实际情况修改
  timeout: 30000, // 增加超时时间到30秒
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 处理成功响应
    return response.data;
  },
  error => {
    // 处理错误响应
    if (error.response) {
      // 服务器返回错误
      const { status } = error.response;
      
      // 401错误处理（未授权）
      if (status === 401) {
        // 清除token，跳转登录页
        localStorage.removeItem('token');
        location.href = '/login';
      }
    } else if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      // 超时错误，如果有响应数据则返回
      if (error.response && error.response.data) {
        console.warn('请求超时，但数据已接收');
        return error.response.data;
      }
      console.error('请求超时');
    } else if (error.request) {
      // 请求已发出但未收到响应
      console.error('服务器未响应');
    } else {
      // 请求配置异常
      console.error('请求异常:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// API方法封装
export const api = {
  // 登录
  login: (data) => {
    return instance.post('/login.php', data);
  },
  
  // 注册
  register: (data) => {
    return instance.post('/register.php', data);
  },
  
  // 获取用户信息
  getUserInfo: () => {
    return instance.get('/getUserInfo.php');
  },
  
  // 生成卡密（仅管理员可用）
  generateCardKey: (data) => {
    return instance.post('/generateCardKey.php', data);
  },
  
  // 兑换卡密
  exchangeCardKey: (data) => {
    return instance.post('/exchangeCardKey.php', data);
  },
  
  // 上传或获取动作文件
  uploadAction(data, fileName) {
    const config = {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    };

    if (fileName) {
      // DELETE 请求 - 删除动作文件
      return instance.delete(`/uploadAction.php?file=${fileName}`, config);
    } else if (data) {
      // POST 请求 - 上传动作文件
      return instance.post('/uploadAction.php', data, config);
    } else {
      // GET 请求 - 获取动作文件列表
      config.timeout = 60000; // 60秒
      return instance.get('/uploadAction.php', config);
    }
  },

  // 获取动作信息
  getActionInfo: (id) => {
    return instance.get(`/editAction.php?id=${id}`);
  },

  // 更新动作信息
  updateAction: (data) => {
    return instance.post('/editAction.php', data);
  },

  // 获取动作列表
  getActions: () => {
    return instance.get('/getActions.php');
  },

  // 获取动作预览图
  getActionPreview: (actionId) => {
    return instance.get(`/getActionPreview.php?id=${actionId}`);
  },

  // 扣除积分
  deductPoints: (data) => {
    return instance.post('/deductPoints.php', data);
  },
};

export default instance; 